"use strict";
exports.__esModule = true;
exports.RevenueFileStatus = void 0;
exports.RevenueFileStatus = {
    VALID: {
        Value: "VALID",
        Label: "Valid",
        BackgroundColor: "green",
        color: "white",
        SortOrder: 0
    },
    EXISTING: {
        Value: "EXISTING",
        Label: "Existing",
        BackgroundColor: "orange",
        color: "white",
        SortOrder: 2
    },
    UNKNOWN: {
        Value: "UNKNOWN",
        Label: "Unknown",
        BackgroundColor: "grey",
        color: "white",
        SortOrder: 3
    },
    DUPLICATE: {
        Value: "DUPLICATE",
        Label: "Duplicate",
        BackgroundColor: "brown",
        color: "white",
        SortOrder: 1
    }
};
//# sourceMappingURL=common-tax-filing.type.js.map